import { render, staticRenderFns } from "./PressKitLogos.vue?vue&type=template&id=286f43e8"
import script from "./PressKitLogos.vue?vue&type=script&lang=js"
export * from "./PressKitLogos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports